<nz-layout>
  <nz-header class="section-header">
    {{'Alerts'|translate}}
  </nz-header>
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path==componentPaths.allergies) {
        <app-allergies [id]="cm.path" />
      }
      @if (cm.path==componentPaths.medicalAlert) {
        <app-medical-alert [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>